import {DEFAULT_PROJECT_NAME} from '../../../agentChat/runtime/backend';
import type {ThreadHistoryItem} from './useThreadHistory';

/**
 * getProjectChipLabel returns the chip label for a history row, or null when
 * no chip should be shown (project is the backend default or missing).
 * Format: `project` when the row's entity matches the current entity, else
 * `entity/project`.
 */
export function getProjectChipLabel(
  item: Pick<ThreadHistoryItem, 'entity' | 'project'>,
  currentEntity: string | null
): string | null {
  if (!item.project || item.project === DEFAULT_PROJECT_NAME) {
    return null;
  }

  return currentEntity && item.entity === currentEntity
    ? item.project
    : `${item.entity}/${item.project}`;
}
